import { ApplicationConfig } from '@angular/core';
import { PreloadAllModules, provideRouter, RouteReuseStrategy, withPreloading } from '@angular/router';
import { routes } from './app.routes';
import { importProvidersFrom } from '@angular/core';
import { TegelModule } from './shared/tegel.module';
import { provideClientHydration } from '@angular/platform-browser';

import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { toastInterceptor } from './core/interceptors/toast.interceptor';
import { CustomReuseStrategy } from './core/custom-reuse.strategy';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { WebpackTranslateLoader } from './core/services/webpack-translate-loader.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      routes, 
      withPreloading(PreloadAllModules)
    ),
    { provide: RouteReuseStrategy, useClass: CustomReuseStrategy },
    provideHttpClient(
      withInterceptors([authInterceptor, toastInterceptor])
    ),
    provideClientHydration(),
    importProvidersFrom(
      TegelModule,
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useClass: WebpackTranslateLoader,
        },
        defaultLanguage: 'en',
      })
    ),
  ],
};
